/**
 * Раздел мини-игр (маршрут /games, И6). Намеренно без ссылки в основном меню главной
 * (доступен по прямой ссылке/через /about по усмотрению). В Фазе 2 — каркас-витрина:
 * каталог-плейсхолдер будущих мини-игр с пометкой «скоро» и приглашение вернуться к
 * классическому квизу. Реализация отдельных мини-игр — более крупная задача (после И7).
 *
 * i18n: переводится только UI-обвязка (заголовки/плашки/CTA). Сами мини-игры
 * (названия/описания в MINI_GAMES) — это контент авторов, он остаётся как есть.
 */
import { useTranslation } from 'react-i18next';
import { Link } from '../components/ui';

interface MiniGame {
  readonly id: string;
  readonly title: string;
  readonly desc: string;
}

/** Каталог-плейсхолдер будущих мини-игр (контент — НЕ переводится, см. план И2). */
const MINI_GAMES: readonly MiniGame[] = [
  { id: 'blitz', title: 'Блиц', desc: 'Серия быстрых вопросов на время' },
  { id: 'duel', title: 'Дуэль', desc: 'Один на один до первой ошибки' },
  { id: 'chain', title: 'Цепочка слов', desc: 'Связи между понятиями' },
  { id: 'wheel', title: 'Колесо вопросов', desc: 'Случайный вопрос из общего пула' },
];

export function Games(): JSX.Element {
  const { t } = useTranslation();
  return (
    <main className="card card--page" aria-labelledby="games-title">
      <Link to="/" className="back">
        {t('nav.back')}
      </Link>
      <p className="block-subtitle">{t('games.sectionLabel')}</p>
      <h1 id="games-title" className="page-title">
        {t('games.title')}
      </h1>
      <p className="muted">{t('games.intro')}</p>

      <ul className="games-grid" aria-label={t('games.listAria')}>
        {MINI_GAMES.map((g) => (
          <li key={g.id} className="game-card game-card--soon">
            <h2 className="game-card__title">{g.title}</h2>
            <p className="game-card__desc muted small">{g.desc}</p>
            <span className="game-card__badge">{t('games.soonBadge')}</span>
          </li>
        ))}
      </ul>

      <div className="games-cta">
        <p className="muted small">{t('games.ctaHint')}</p>
        <Link to="/" className="cta">
          {t('games.classicQuiz')}
        </Link>
      </div>
    </main>
  );
}
